import {mapActions} from 'vuex';
import {CART_ITEM_TYPE, WEBITEM_TYPE, PRODUCT_IMAGE_PREFIX} from '../../../../common/constants/constants';
import createProductUrl from '../../../../common/utils/create-product-url';

export default {
	name: 'basket-webitem',
	props: {
		data: {
			type: Object,
			required: true
		},
		cartId: {
			type: String,
			required: true
		}
	},
	computed: {
		productUrl() {
			return createProductUrl(this.data.id);
		},

		PRODUCT_IMAGE_PREFIX() {
			return PRODUCT_IMAGE_PREFIX;
		},

		TYPE() {
			return CART_ITEM_TYPE;
		},

		type() {
			if (this.products.length == 1 && !this.services.length) {
				return CART_ITEM_TYPE.PRODUCT;
			} else if (this.services.length == 1 && !this.products.length) {
				return CART_ITEM_TYPE.SERVICE;
			} else {
				return CART_ITEM_TYPE.WEBITEM;
			}
		},

		services() {
			return this.data.items.filter(item => item.type == WEBITEM_TYPE.SOLO_SZOLG || item.type == WEBITEM_TYPE.KOMB_SZOLG) || [];
		},

		products() {
			return this.data.items.filter(item => item.type == WEBITEM_TYPE.PRODUCT) || [];
		}
	},
	methods: {
		...mapActions('cartsStore', ['removeFromCart']),

		remove() {
			this.removeFromCart({
				webItemId: this.data.id,
				cartId: this.cartId
			});
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/HEA01-header/HEA01-header-basket/basket-webitem/basket-webitem.js